export enum KnaufPalettes {
    MiejskiSzyk,
    KlasycznaElegancja,
    SwiatoweInspiracje,
    WZgodzieZNatura,
    // TopDesign,
    WszystkieKolory,
    invalid,
}
